import React, { useEffect, useState } from 'react'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import backgroundImage from "../assets/events_bg.png"
import "../styles/events.css"
import CalendarComponent from '../components/calendar'
import withScroll from '../components/scroll'
import { Helmet } from 'react-helmet'
import { fetchEvents } from '../components/contentfulFiles'

const EventsPage = ({ sectionRef, handleScroll }) => {
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('all')

  useEffect(() => {
    const getData = async () => {
      const fetchedEvents = await fetchEvents()
      setEvents(fetchedEvents)
      setLoading(false)
    }
    getData()
  }, [])

  const filteredEvents = events.filter((event) => {
    if (filter === 'featured') return event.fields.bigEvent === true
    return true
  })

  return (
    <div className="calvary-events">
      <Helmet>
        <title>Events - Calvary First Nigerian SDA Church</title>
      </Helmet>
      <Navbar />
      <main>

        {/* ── Hero ── */}
        <section
          className="events-hero"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <div className="events-hero-content">
            <h1>Like to join<br />our events?</h1>
          </div>
          <div className="events-hero-buttons">
            <button className="events-btn" onClick={handleScroll}>See All Events</button>
          </div>
        </section>

        {/* ── All Events Grid ── */}
        <section ref={sectionRef} className="all-events">
          <h2>All Events</h2>
          <p className="all-events-sub">Browse upcoming and recent events from our community</p>

          {/* Filter tabs */}
          <div className="events-filter-row">
            <button
              className={`events-filter-pill ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              All
            </button>
            <button
              className={`events-filter-pill ${filter === 'featured' ? 'active' : ''}`}
              onClick={() => setFilter('featured')}
            >
              Featured
            </button>
          </div>

          {loading ? (
            <p className="events-status">Loading events...</p>
          ) : filteredEvents.length > 0 ? (
            <div className="events-grid">
              {filteredEvents.map((event) => (
                <div
                  key={event.sys.id}
                  className={`epc ${event.fields.bigEvent ? 'epc-featured' : ''}`}
                >
                  <div className="epc-img">
                    {event.fields.image?.fields?.file?.url ? (
                      <img
                        src={`https:${event.fields.image.fields.file.url}`}
                        alt={event.fields.eventName}
                      />
                    ) : (
                      <div className="epc-img-fallback">No image</div>
                    )}
                  </div>
                  <div className="epc-body">
                    {event.fields.bigEvent ? (
                      <span className="epc-tag epc-tag-featured">⭐ Featured</span>
                    ) : (
                      <span className="epc-tag">Event</span>
                    )}
                    <h3 className="epc-title">{event.fields.eventName}</h3>
                    <p className="epc-desc">{event.fields.eventDescription}</p>
                    <div className="epc-pills">
                      <span className="epc-pill">📅&nbsp; {event.fields.date}</span>
                      <span className="epc-pill">🕐&nbsp; {event.fields.time}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="events-status">
              No {filter === 'featured' ? 'featured ' : ''}events at the moment. Please check back later.
            </p>
          )}
        </section>

        {/* ── Calendar ── */}
        <section className="events-calendar">
          <h2>Events Calendar</h2>
          <p className="all-events-sub">View all events by date</p>
          <CalendarComponent />
        </section>

      </main>
      <Footer />
    </div>
  )
}

export default withScroll(EventsPage)